import { 
  mapProps 
} from 'recompose'

import {
  getFrontMatter,
  getSiteTitle,
  getPosts,
  getImage,
  getHtml
} from './selectors'

export const postEnhancer = mapProps(({data}) => ({
  siteTitle: getSiteTitle(data),
  posts: getPosts(data),
}))

export const postsEnhancer = mapProps(({ data }) => ({
  image: getImage(data),
  html: getHtml(data),
  frontmatter: getFrontMatter(data),
  siteTitle: getSiteTitle(data),
}))


// WEBPACK FOOTER //
// ./src/utils/enhancers.js